import { DataType } from "./dataType"
import { TenantFeatures } from "./tenantFeatures"

export interface FieldType {
	id: string
	title: string
	description: string
	type: DataType

	requiredFeature?: TenantFeatures
}

/**
* @deprecated use FieldDataTypes
* replace FieldTypeId with FieldDataTypes if possible
*/
export enum FieldTypeId {
	Text = "text",
	TextArea = "text-area",
	Number = "number",
	Dollar = "dollar",
	Date = "date",
	DateTime = "date-time",
	Checkbox = "checkbox",
	List = "list",
	ListMultiple = "list-multiple",
	ListData = "list-data",
	UserRole = "user-role",
	MapMarker = "map-marker",
	Calculated = "calculated",
	ExternalLink = "external-link",
	CaseNumber = "case-number",
	TimeSpent = "time-spent",
	FileOnly = "file-only",
	FieldMetrics = "field-metrics",
	User = "user", // the type of 'assignee' built-in field
	AuditUser = "auditUser",
}

export const FieldDataTypes = {
	Text: "text",
	TextArea: "text-area",
	Number: "number",
	Dollar: "dollar",
	Date: "date",
	DateTime: "date-time",
	Checkbox: "checkbox",
	List: "list",
	ListMultiple: "list-multiple",
	ListData: "list-data",
	UserRole: "user-role",
	MapMarker: "map-marker",
	Calculated: "calculated",
	ExternalLink: "external-link",
	CaseNumber: "case-number",
	TimeSpent: "time-spent",
	FileOnly: "file-only",
	FieldMetrics: "field-metrics",
	User: "user", // the type of 'assignee' built-in field
	AuditUser: "auditUser"
}

export const readOnlyFieldTypes = [
	FieldDataTypes.Calculated,
	FieldDataTypes.CaseNumber,
	FieldDataTypes.TimeSpent,
	FieldDataTypes.FieldMetrics
]
